// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useMemo} from 'react';
import {Toast} from './toast';
import {type i_toast, type t_toast_position} from './types';
import {use_toast} from './toast_context';
import styles from './toast.module.less';

const group_by_position = (toasts: i_toast[])=>{
    return toasts.reduce((acc, toast)=>{
        const pos = toast.pos || 'top-right';
        const pos_toasts = acc[pos] || [];
        return {...acc, [pos]: [...pos_toasts, toast]};
    }, {} as Record<t_toast_position, i_toast[]>);
};

export const Toast_container = ()=>{
    const {toasts, remove_toast} = use_toast();
    const grouped_toasts = useMemo(()=>group_by_position(toasts), [toasts]);
    return <div className={styles.toast_container}>
      {Object.entries(grouped_toasts).map(([pos, pos_toasts])=>
        <div key={pos} className={styles.toast_group} data-pos={pos}>
          {pos_toasts.map(toast=>
            <Toast key={toast.id} toast={toast} on_remove={remove_toast}/>
          )}
        </div>
      )}
    </div>;
};
